import { dataFormat4 } from "../../../../functions/dataFormat";
import { zl, zaokr } from "../../../../functions/utilities";

const MieszkaniecDaneWodaRozliczenieWydrukZaliczki = props => {
    
    const { rozliczenieWodyAkt, procent } = props;    
    
    return (
        <section
            style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "30px",
                fontSize: "0.85rem"
            }}
        >
            <div style={{width: "fit-content"}}>
                <table style={{fontSize: "0.7rem"}}>
                    <thead>
                        <tr>
                            <th colSpan={2} style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>
                                {`Naliczone zaliczki za okres ${dataFormat4(procent?.zaliczki_data_poczatek)} - ${dataFormat4(procent?.zaliczki_data_koniec)}`}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                                zimna woda
                            </td>
                            <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>
                                { zl(procent?.zaliczka_zw) }
                            </td>
                        </tr>   
                        {
                            rozliczenieWodyAkt?.abonament_dzien > 0 && (
                                <tr>
                                    <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                                        abonament cw
                                    </td>
                                    <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>
                                        { zl(procent?.zaliczka_abo_cw) }
                                    </td>
                                </tr>
                            )
                        }
                        <tr>
                            <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                                ciepła woda
                            </td>
                            <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>
                                { zl(procent?.zaliczka_cw) }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style={{width: "fit-content"}}>
                <table style={{fontSize: "0.7rem"}}>
                    <thead>
                        <tr>
                            <th colSpan={2} style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>
                                Koszt jednostkowy
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                                zimna woda
                            </td>
                            <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>
                                {zl(rozliczenieWodyAkt?.metr_3_zimnej)}
                            </td>                    
                        </tr>
                        {
                            rozliczenieWodyAkt?.abonament_dzien > 0 && (
                                <tr>
                                    <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                                        abonament cw
                                    </td>
                                    <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>  
                                        {zaokr(procent?.abonament_pozorny_msc)}zł
                                    </td>   
                                </tr> 
                            )
                        }
                        <tr>                
                            <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                                ciepła woda
                            </td>
                            <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>  
                                {zl(rozliczenieWodyAkt?.kosztPodgrzaniaCieplej)}
                            </td>  
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    )
}

export default MieszkaniecDaneWodaRozliczenieWydrukZaliczki;